const BorderRadius = {
  STANDARD: 3
};

const Breakpoints = {
  XS: 0,
  SM: 768,
  MD: 992,
  LG: 1200
};

const ContainerWidths = {
  SM: 750,
  MD: 970,
  LG: 1170
};

const FontSizes = {
  ROOT: 16,

  BUTTON_SM: 14,
  BUTTON: 16,

  SUBTEXT: 12,
  COPY: 14,
  COPY_LG: 16,

  LEAD_MOBILE: 18,
  LEAD: 20,

  H1: 58,
  H2: 32,
  H3: 20,
  H4: 14,
  H5: 14
};

const FontWeights = {
  SEMIBOLD: 500
};

const LineHeights = {
  BUTTON_SM: 16,
  BUTTON: 24,

  COPY_SM: 16,
  COPY: 24,
  COPY_LG: 32,

  LEAD: 32,

  SUBTEXT: 24,

  H1: 52,
  H2: 32,
  H3: 32,
  H4: 16,
  H5: 16
};

const Padding = {
  CLOSE_BUTTON: 2
};

const Spacing = {
  M_Y_XXS: 8,
  M_Y_XS: 12,
  M_Y_SM: 16,
  M_Y: 24,
  M_Y_LG: 32,
  M_Y_XL: 40,
  M_Y_XXL: 64,
  M_Y_XXXL: 80,

  M_X_XS: 5,
  M_X_SM: 10,
  M_X: 15,
  M_X_LG: 30,

  P_Y_XXS: 4,
  P_Y_XS: 8,
  P_Y_SM: 12,
  P_Y: 16,
  P_Y_LG: 24,
  P_Y_XL: 32,

  P_X_XS: 5,
  P_X_SM: 10,
  P_X: 15,
  P_X_LG: 30,
  P_X_XL: 45,
  P_X_XXL: 60,

  GUTTER: 30
};

const Heights = {
  CIRCLED_ICON: 35,

  CHECKBOX: 24,
  RADIO_BUTTON: 24
};

const ZIndexes = {
  HOVER_DROPDOWN_MENU: 100,
  MODAL_BACKDROP: 1000
};

const Timing = {
  COLLAPSIBLE_EXPAND: 350
};

const Widths = {
  ALERT_MAX: 556,
  ICON: 40
};

export {
  FontSizes,
  FontWeights,
  LineHeights,
  Spacing,
  Padding,
  BorderRadius,
  ContainerWidths,
  Breakpoints,
  Heights,
  Timing,
  ZIndexes,
  Widths
};
